import AxiosService from "plugins/TS-lib-utils-public/services/AxiosService"; 

class PracticeOrdersService extends AxiosService {
    constructor() {
        super('management');
    }

    getOrder = async (orderId, { cancelToken = null } = {}) => {
        return await this.get(
            `/practice-orders/${orderId}`,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }
  
    getOrdersList = async (page, limit, search = null, { cancelToken = null } = {}) => {
        let query;
        if (search) {
            query = `/practice-orders/list/?page=${page}&limit=${limit}&search=${search}`;
        } else {
            query = `/practice-orders/list/?page=${page}&limit=${limit}`;
        }
        const response = await this.get(
            query,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
        return response;
    };

    createOrder = async (data, { cancelToken = null } = {}) => {
        return await this.post(
            `/practice-orders`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    editOrder = async (data, { cancelToken = null } = {}) => {
        return await this.put(
            `/practice-orders/${data._id}`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    getReservedKits = async (orderId, { cancelToken = null } = {}) => {
        return await this.get(
            `/practice-orders/${orderId}/kits/`,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                    
                },
                cancelToken: cancelToken
            }
        );
    }

    deleteKitFromOrder = async (orderId, kitId, kitType, { cancelToken = null } = {}) => {
        return await this.delete(
            `/practice-orders/${orderId}/kits/${kitId}`,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                    kit_type: kitType
                },
                cancelToken: cancelToken
            }
        );
    }

    cancelOrder = async (orderId, { cancelToken = null } = {}) => {
        return await this.delete(
            `/practice-orders/${orderId}`,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    autoAssignKits = async (orderId, { cancelToken = null } = {}) => {
        return await this.get(
            `/practice-orders/${orderId}/auto-assign`,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

}
export default new PracticeOrdersService();
